import React from 'react'

import { ProfileResponsiveSheet } from 'app/ProfileRevampPage/components/ProfileResponsiveSheet'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'

interface ISubjectsDrawerProps {
  isOpen: boolean
  onClose: () => void
  onCloseButtonClicked: () => void
}

export const SubjectsDrawer = ({
  isOpen,
  onClose,
  onCloseButtonClicked,
}: ISubjectsDrawerProps) => {
  const { profileData } = useProfile()
  return (
    <ProfileResponsiveSheet
      isOpen={isOpen}
      onClose={onClose}
      onCloseButtonClicked={onCloseButtonClicked}
      title="Mata Pelajaran"
      autoFocus={false}
    >
      <div data-testid="profile-subjects-all" className="px-3 py-4">
        <ul className="list-disc ml-6">
          {(profileData.subjects ?? []).map((subject, index) => (
            <li key={`profile-subject-item-${index}`}>
              <div className="truncate">{subject}</div>
            </li>
          ))}
        </ul>
      </div>
    </ProfileResponsiveSheet>
  )
}
